export const statusOptions = {
  'CALCULATED': { 
    value: 'CALCULATED', 
    label: 'Calculada' 
  },
  'APPROVED': { 
    value: 'APPROVED', 
    label: 'Aprobada' 
  },
  'REJECTED': { 
    value: 'REJECTED', 
    label: 'Rechazada' 
  },
  'DOWNLOADED': { 
    value: 'DOWNLOADED', 
    label: 'Descargada' 
  }
}